
import moment from 'moment' 

export const APIDateFormat = 'DD MMMM YYYY'
export const APIDateTimeFormat = 'DD MMMM YYYY HH:mm:ss'
export const defaultFromDate = moment().subtract(1, 'days').startOf('day')
export const UIDateFormat = "DD-MM-YYYY"
export const UITimeFormat = "HH:mm"
export const UIFileFormat = "DD-MM-YYYY-HH-mm-ss"